import * as React from "react";
import useInputStateSummary from "hooks/useInputStateSummary";
import MenuItemDotBadge from "components/navigation/MenuItemDotBadge";
const InputsDotBadge = ({ text, hasExternalIssues = false, externalIssuesTitle = "" }) => {
  const { hasProblematicInputs, isLoading } = useInputStateSummary();
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, text);
  }
  const showDot = hasProblematicInputs || hasExternalIssues;
  const title = hasProblematicInputs ? "Some inputs are in failed state or in setup mode." : externalIssuesTitle;
  return /* @__PURE__ */ React.createElement(MenuItemDotBadge, { text, title, showDot });
};
export default InputsDotBadge;
